import React, { FC } from 'react';
import { Text } from 'react-native';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { font as initialFont } from '@styles/fonts';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';
import { NCFileBatchEventsProps } from '@v2/pages/common/components/NCFileBatchEvents';

export interface BatchCellProps extends Pick<EventStatusSubStatusExecModeProps, 'event'>, Pick<NCFileBatchEventsProps, 'eventType' | 'C' | 'font'>, Pick<UseTableColumnsParams, 'textConfig'> {
  isMultiOrSingleMachinePerspective?: boolean;
}

const BatchCell: FC<BatchCellProps> = ({
  event,
  eventType,
  textConfig,
  C,
  font = initialFont,
  isMultiOrSingleMachinePerspective = false
}) => {
  const batchText = textConfig.batch?.[eventType]?.(event) ?? '';

  const textColor = isMultiOrSingleMachinePerspective
    ? C('Label/Light/Tertiary')
    : C('Label/Light/Primary');

  return (
    <Text style={[font['Subhead 2'], { color: textColor }]}>
      {batchText}
    </Text>
  );
};

export default React.memo(BatchCell, (prev, next) => {
  return (
    prev.event.sequenceNumber === next.event.sequenceNumber &&
    prev.eventType === next.eventType &&
    prev.C.scheme === next.C.scheme &&
    prev.isMultiOrSingleMachinePerspective === next.isMultiOrSingleMachinePerspective
  );
});
